import { Box } from '@chakra-ui/react';
import React from 'react';

interface Props {
  isOpen: boolean;
}

const SearchBarBackdrop = ({ isOpen }: Props) => {
  return null;
};

export default React.memo(SearchBarBackdrop);
